import { jsx as l } from "react/jsx-runtime";
const o = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M5.979 10.182a4.5 4.5 0 1 1 6.364-6.364 4.5 4.5 0 0 1-6.364 6.364m9.45-7.055a.8.8 0 0 0-.906 1.15v.001l.004.007.02.04q.027.054.079.166c.067.147.157.362.248.623.184.53.355 1.21.355 1.886s-.17 1.357-.355 1.886a8 8 0 0 1-.327.79l-.02.038-.003.008a.8.8 0 0 0 .906 1.15 4 4 0 0 0 0-7.745M2.662 18.017V19.5a2 2 0 0 0 2 1.999h9a2 2 0 0 0 2-2v-1.484a4.645 4.645 0 0 0-4.645-4.645h-3.71a4.645 4.645 0 0 0-4.645 4.645m15.414-4.411a1 1 0 0 0-1.341 1.341c.93 2.203 1.225 5.677 0 6.553h2.605a2 2 0 0 0 2-2v-1.006a5.22 5.22 0 0 0-1.199-3.339c-.737-.896-2.065-1.55-2.065-1.55",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  o as default
};
